export const INPUT_DATA_COMBINATION_REQUEST = "INPUT_DATA_COMBINATION_REQUEST";
export const INPUT_DATA_COMBINATION_SUCCESS = "INPUT_DATA_COMBINATION_SUCCESS";
export const INPUT_DATA_COMBINATION_FAILURE = "INPUT_DATA_COMBINATION_FAILURE";
